import { render, staticRenderFns } from "./AppBreadcrumb.vue?vue&type=template&id=520ee1f4"
import script from "./AppBreadcrumb.vue?vue&type=script&lang=js"
export * from "./AppBreadcrumb.vue?vue&type=script&lang=js"
import style0 from "./AppBreadcrumb.vue?vue&type=style&index=0&id=520ee1f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports